import {
  Backdrop,
  Box,
  Button,
  Grid,
  Link as MuiLink,
  ListItemIcon,
  makeStyles,
  Menu,
  MenuItem,
  Switch,
  Theme,
  TextField,
  IconButton,
  Typography,
} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import EditIcon from "@material-ui/icons/Edit";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import { Tooltip } from "@mui/material";
import { GridRowModel } from "@mui/x-data-grid-pro";
import { useFormik } from "formik";
import moment from "moment";
import "moment-timezone";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useAppSelector } from "src/app-redux/hooks";
import { loader as vehicleLoader, setSelectedVehicleId } from "src/app-redux/vehicle/vehicleSlice";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import NewCommonButton from "src/components/CommonButton/NewCommonButton";
import CommonDataGridPage from "src/components/CommonDataGridPage/CommonDataGridPage";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import { VehicleManagementRoute } from "../../vehicle-management.routes";
import { columns, forwarderImporterColumns } from "./components/columns";
import { getPrintFile, searchData } from "src/app-redux/common-actions";
import {
  getVehicleDetailsByIdAction,
  markVehicleEntryAsReview,
} from "src/app-redux/vehicle/actions/vehicleActions";
import Drawer from "./components/Drawer";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import {
  PrintSharp,
  CancelRounded,
  MoreVert,
  Warning,
  Check,
  Close,
  Info,
} from "@material-ui/icons";
import { loader as gateEntryLoader } from "src/app-redux/gate-entry/gateEntrySlice";
import { filteryByArr } from "src/common/utils/app.dropdowns";
import { filterBy } from "src/common/utils/helpers";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import DuplicateReceiptDialog from "src/components/AlertDialog/DuplicateReceiptDialog";
import { object, string } from "yup";
import { getActiveApprovalUsers } from "src/app-redux/configuration/actions/configurationActions";
import { selectAllActiveApprovalUserList } from "src/app-redux/configuration/configurationSlice";
import TransitionDialog from "src/components/AlertDialog/TransitionDialog";
import CommonLoader from "src/components/Loader/CommonLoader";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 500,
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
    color: "#000",
  },
  breadcrumbs: {
    fontSize: theme.typography.pxToRem(12),
  },
  button: {
    margin: theme.spacing(1),
  },
  hideDatesGrid: {
    display: "none",
  },
  customButton: {
    "& .MuiButton-iconSizeSmall": {
      marginRight: "0",
    },
    "& .MuiBox-root": {
      marginRight: "8px",
    },
  },
  menu: {
    left: "0",
    "& .MuiPopover-paper": {
      width: "max-content",
    },
  },
}));

interface Props {}

export function ListContainers({}: Props): React.ReactElement {
  const isExportString = localStorage.getItem("isAllowToExportData");
  const isExport = isExportString === "true";
  const classes = useStyles();
  const terminalType = Number(localStorage.getItem("terminalType"));
  const insertColumnsAfter = (cols: any[], afterKey: string, toInsert: any[]) => {
    const index = cols.findIndex((column: any) => column.accessorKey === afterKey);
    if (index === -1) return [...cols, ...toInsert];
    return [...cols.slice(0, index + 1), ...toInsert, ...cols.slice(index + 1)];
  };

  const listContainersColumns =
    terminalType === 4
      ? insertColumnsAfter(
          columns.filter(
            (column: any) => !["vessel", "yardSlotInfo", "gdNumber"].includes(column.accessorKey)
          ),
          "vehicleNumber",
          forwarderImporterColumns
        )
      : columns;

  const [displayColumns, setDisplayColumns] = React.useState<any>(listContainersColumns);
  const moduleName = VehicleManagementRoute.title;
  const [vehicleRecord, setvehicleRecord] = React.useState<GridRowModel[]>([]);
  const pageHeading = "List of Containers";
  const [loader, setLoader] = useState<any>(false);
  const loader2: any = useAppSelector(vehicleLoader);
  const receiptLoader: any = useAppSelector(gateEntryLoader);
  const [isCustomDate, setIsCustomDate] = useState<boolean>(false);
  const history = useHistory();
  const startDatePickerRef: any = useRef(null);
  const endDatePickerRef: any = useRef(null);

  const [listAction, setListAction] = useState<any>(null);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClickActionBtn = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseActionBtn = () => {
    setAnchorEl(null);
  };

  const [isDrawerOpen, setisDrawerOpen] = React.useState(false);
  const handleCloseDrawer = () => {
    setisDrawerOpen(false);
  };
  const dispatch = useDispatch();

  const [isOpenConfirmationDailog, setIsOpenConfirmationDailog] = useState<boolean>(false);
  const [invalidVehicleId, setInvalidVehicleId] = useState<number>(0);
  const [remarks, setRemarks] = useState("");
  const allApprovalUserList = useAppSelector(selectAllActiveApprovalUserList);
  const [isOpenInfoDailog, setIsOpenInfoDailog] = useState<boolean>(false);

  const handleCloseConfirmationDialog = () => {
    formik.resetForm();
    formik.setValues({
      ...formik.initialValues,
      InProgressVehiclesDataOnly: formik.values.InProgressVehiclesDataOnly,
      filterBy: formik.values.filterBy,
      startDate: formik.values.startDate,
      endDate: formik.values.endDate,
    });
    setIsOpenConfirmationDailog(false);
  };
  const handleCloseInfoDialog = () => {
    setIsOpenInfoDailog(false);
  };

  const handleConfirmationDialog = async () => {
    formik.submitForm();
  };

  useEffect(() => {
    if (vehicleRecord.length) {
      const transformedColumns: any = listContainersColumns.map((column: any) =>
        column.accessorKey === "actionButtons"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return row.original.isDeleted || row.original.isOnHold === 1 ? (
                  <>
                    <Tooltip
                      title={
                        row.original.isOnHold === 1
                          ? "This container has been marked hold"
                          : "This entry has been marked as invalid"
                      }
                      placement="bottom-start"
                    >
                      <span className={classes.customButton}>
                        <NewCommonButton
                          style={{ minWidth: "30px", padding: "4px" }}
                          icon={<Warning />}
                        >
                          {/* Marked as Wrong Entry */}
                        </NewCommonButton>
                      </span>
                    </Tooltip>
                  </>
                ) : (
                  <React.Fragment>
                    <Box>
                      <Tooltip title="More">
                        <Button
                          onClick={(e) => {
                            row.original?.notes != null || row.original?.notes != undefined
                              ? setRemarks(row.original?.notes)
                              : setRemarks("");
                            setListAction(row.original);
                            handleClickActionBtn(e);
                          }}
                          aria-controls={open ? "account-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? "true" : undefined}
                          style={{ minWidth: "30px", padding: "4px" }}
                        >
                          <MoreVert />
                        </Button>
                      </Tooltip>
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column.accessorKey === "isScanComplete"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <React.Fragment>
                    <Box>
                      <Tooltip title={row.original?.isScanComplete ? "Yes" : "No"}>
                        <Button style={{ minWidth: "30px", padding: "4px", color: "gray" }}>
                          {row.original?.isScanComplete ? <Check /> : <Close />}
                        </Button>
                      </Tooltip>
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column.accessorKey === "isWeightDone"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <React.Fragment>
                    <Box>
                      <Tooltip title={row.original?.isWeightDone ? "Yes" : "No"}>
                        <Button style={{ minWidth: "30px", padding: "4px", color: "gray" }}>
                          {row.original?.isWeightDone ? <Check /> : <Close />}
                        </Button>
                      </Tooltip>
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column.accessorKey === "isCommercialDone"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <React.Fragment>
                    <Box>
                      <Tooltip title={row.original?.isCommercialDone ? "Yes" : "No"}>
                        <Button style={{ minWidth: "30px", padding: "4px", color: "gray" }}>
                          {row.original?.isCommercialDone ? <Check /> : <Close />}
                        </Button>
                      </Tooltip>
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column.accessorKey === "vehicleInProgress"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <React.Fragment>
                    <Box>
                      <Tooltip title={row.original?.vehicleInProgress ? "Yes" : "No"}>
                        <Button style={{ minWidth: "30px", padding: "4px", color: "gray" }}>
                          {row.original?.vehicleInProgress ? <Check /> : <Close />}
                        </Button>
                      </Tooltip>
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column.accessorKey === "isAnomlyDetected"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <React.Fragment>
                    <Box>
                      <Tooltip title={row.original?.isAnomlyDetected ? "Yes" : "No"}>
                        <Button style={{ minWidth: "30px", padding: "4px", color: "gray" }}>
                          {row.original?.isAnomlyDetected ? <Check /> : <Close />}
                        </Button>
                      </Tooltip>
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column.accessorKey === "containerNumber"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                const isDisabled = row.original.isOnHold === 1;
                return (
                  <>
                    <MuiLink
                      className={`customMuiLink ${isDisabled ? "disabled" : ""}`}
                      onClick={() => {
                        if (isDisabled) return; // prevent click
                        dispatch(getVehicleDetailsByIdAction(row.original.id));
                        dispatch(setSelectedVehicleId(row.original.id));
                        setisDrawerOpen(true);
                      }}
                    >
                      {renderedCellValue}
                    </MuiLink>
                  </>
                );
              },
            }
          : column
      );

      setDisplayColumns(transformedColumns);
    }
  }, [vehicleRecord]);

  const formik = useFormik<any>({
    initialValues: {
      InProgressVehiclesDataOnly: true,
      filterBy: "today",
      vehicleStatusId: 10,
      startDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      endDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(23, 59)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      remarks: "",
      approvalUserId: "",
      userName: "",
      regNumber: "",
    },
    validationSchema: object({
      remarks: string()
        .required("This field is required")
        .max(3000, "Maximum 3000 characters are allowed"),
      approvalUserId: string().required("This field is required"),
    }),
    onSubmit: async (values) => {
      const params = {
        gatePassId: invalidVehicleId,
        invalidRemarks: values?.remarks,
        approvalUserId: values.approvalUserId,
        userName: values.userName,
        regNumber: values.regNumber,
      };
      handleCloseConfirmationDialog();
      if (invalidVehicleId) {
        const res: any = await dispatch(markVehicleEntryAsReview(params));

        formik.setFieldValue("remarks", "");
        formik.setFieldValue("filterBy", "today");
        handleSearch();
      }
    },
  });
  const handleSearch = async () => {
    const { filterBy, startDate, endDate, InProgressVehiclesDataOnly } = formik.values;
    const body = {
      filterBy: filterBy || null,
      startDate: startDate || null,
      endDate: endDate || null,
      InProgressVehiclesDataOnly: InProgressVehiclesDataOnly || false,
    };
    setvehicleRecord([]);
    setLoader(true);
    try {
      const results: any = await dispatch(
        searchData("/get-all-gate-entries", JSON.stringify(body))
      );
      const apiRecord = results?.gateEnteries;
      if (apiRecord) {
        const transformedData = apiRecord
          .filter((data: any) => data.containerNumber != null)
          .map((data: any, index: any) => {
            return {
              ...data,
              id: data.gatePassId,
              yardSlotInfo:
                data.yardName && data.rowName && data.slotNumber
                  ? `${data.yardName}, Row ${data.rowName}, Slot ${data.slotNumber}`
                  : "",
            };
          });
        setvehicleRecord(transformedData);
      }
    } catch (error) {
      setLoader(false);
    }
    setLoader(false);
  };

  const [resetHandler, setResetHandler] = useState(false);
  const resetSearch = () => {
    formik.setValues(formik.initialValues);
    setIsCustomDate(false);
    setResetHandler(true);
  };

  useEffect(() => {
    formik.setFieldValue("filterBy", "today");
    handleSearch();
    setResetHandler(false);
    dispatch(getActiveApprovalUsers());
  }, [resetHandler]);
  const filterByAction = (data: any) => {
    formik.setFieldValue("filterBy", data.value);
    if (data && data.value) {
      const res = filterBy(data);
      if (res?.isCustomDate) {
        setIsCustomDate(true);
        formik.setFieldValue("startDateCustom", res?.startDate);
        formik.setFieldValue("endDateCustom", res?.endDate);
      } else {
        setIsCustomDate(false);
      }
      formik.setFieldValue("startDate", res?.startDate);
      formik.setFieldValue("endDate", res?.endDate);
    }
  };

  const [isOpenGateInPrintDailog, setIsOpenGateInPrintDailog] = useState<boolean>(false);
  const [isOpenGateOutPrintDailog, setIsOpenGateOutPrintDailog] = useState<boolean>(false);
  const [isPrintTallyDailog, setisPrintTallyDailog] = useState<boolean>(false);
  const [isPrintDestuffingDailog, setisPrintDestuffingDailog] = useState<boolean>(false);
  const [selectedRecordId, setSelectedRecordId] = useState(null);

  const printReceiptGateIn = async (isDuplicate: string) => {
    setIsOpenGateInPrintDailog(false);
    const dateTime = moment().format("DD MMM YYYY, HH:mm");
    const fileMetaData = {
      url: `${process.env.REACT_APP_API_URL}/get-gate-entry-slip-by-gate-pass-id/${selectedRecordId}?isDuplicate=${isDuplicate}&printDateTime=${dateTime}`,
      contentType: ".pdf",
      fileName: "testPdf.pdf",
    };
    await dispatch(getPrintFile(fileMetaData, dispatch));
  };

  const printReceiptGateOut = async (isDuplicate: string) => {
    setIsOpenGateOutPrintDailog(false);
    const dateTime = moment().format("DD MMM YYYY, HH:mm");
    const fileMetaData = {
      url: `${process.env.REACT_APP_API_URL}/get-gate-out-slip-by-gate-pass-id/${selectedRecordId}?isDuplicate=${isDuplicate}&isNod=true&printDateTime=${dateTime}`,
      contentType: ".pdf",
      fileName: "testPdf.pdf",
    };
    await dispatch(getPrintFile(fileMetaData, dispatch));
  };
  const printTallyReport = async (isDuplicate: string) => {
    setisPrintTallyDailog(false);
    const dateTime = moment().format("DD MMM YYYY, HH:mm");
    const fileMetaData = {
      url: `${process.env.REACT_APP_API_URL}/get-tally-slip-by-gate-pass-id/${selectedRecordId}?isDuplicate=${isDuplicate}&printDateTime=${dateTime}`,
      contentType: ".pdf",
      fileName: "testPdf.pdf",
    };
    await dispatch(getPrintFile(fileMetaData, dispatch));
  };
  const printDestuffingReport = async (isDuplicate: string) => {
    setisPrintDestuffingDailog(false);
    const dateTime = moment().format("DD MMM YYYY, HH:mm");
    const fileMetaData = {
      url: `${process.env.REACT_APP_API_URL}/get-destuffing-slip-by-gate-pass-id/${selectedRecordId}?isDuplicate=${isDuplicate}&printDateTime=${dateTime}`,
      contentType: ".pdf",
      fileName: "testPdf.pdf",
    };
    await dispatch(getPrintFile(fileMetaData, dispatch));
  };
  const exportHandler = async (row: any) => {
    dispatch(
      addNotificationAction({
        message: "Your download will begin shortly",
        options: { variant: "success" },
      })
    );
    const exportedRecords = await row?.map((data: any) => {
      const record: Record<string, any> = {
        Vehicle: data?.vehicleNumber,
        "Container Number": data?.containerNumber,
        Vessel: data?.vessel,
        Driver: data?.driverName,
        Type: data?.vehicleType,
        Status: data?.vehicleStatus,
        Consignment: data?.consignmentType,
        "GD #": data?.gdNumber,
        "VIR #": data?.virNumber,
        "Bill #": data?.billNumber,
        Location: data?.terminalLocation,
        Cargo: data?.cargoTypeName,
        Yard: data?.yardName,
        Entry: data.gateEntryDate ? moment(data.gateEntryDate).format("DD-MM-YYYY hh:mm:ss A") : "",
        Checkout: data.gateOutDate ? moment(data.gateOutDate).format("DD-MM-YYYY hh:mm:ss A") : "",
        Anomaly: data.isAnomlyDetected ? "Yes" : "No",
        "In Progress": data.vehicleInProgress ? "Yes" : "No",
        Scan: data?.isScanComplete ? "Yes" : "No",
        Weight: data?.isWeightDone ? "Yes" : "No",
        Commercial: data?.isCommercialDone ? "Yes" : "No",
      };

      if (terminalType === 4) {
        const { Vehicle, ...rest } = record;
        return {
          Vehicle,
          Forwarder: data?.forwarder,
          Importer: data?.importer,
          ...rest,
        };
      }

      return record;
    });
    return exportedRecords;
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={loader2 || receiptLoader}>
        <CommonLoader />
      </Backdrop>
      <Drawer
        isDrawerOpen={isDrawerOpen}
        handleCloseDrawer={() => {
          handleCloseDrawer();
        }}
      />
      {/* Dialog for Gate-In */}
      <DuplicateReceiptDialog
        isOpen={isOpenGateInPrintDailog}
        handleOriginal={() => {
          printReceiptGateIn("0");
        }}
        heading={"Confirmation"}
        handleDuplicate={() => {
          printReceiptGateIn("1");
        }}
        onClose={() => {
          setIsOpenGateInPrintDailog(false);
        }}
      >
        Which receipt do you want to print?
      </DuplicateReceiptDialog>
      {/* Dialog for gate out */}
      <DuplicateReceiptDialog
        isOpen={isOpenGateOutPrintDailog}
        handleOriginal={() => {
          printReceiptGateOut("0");
        }}
        heading={"Confirmation"}
        handleDuplicate={() => {
          printReceiptGateOut("1");
        }}
        onClose={() => {
          setIsOpenGateOutPrintDailog(false);
        }}
      >
        Which receipt do you want to print?
      </DuplicateReceiptDialog>
      {/* Dialog for print telly report */}
      <DuplicateReceiptDialog
        isOpen={isPrintTallyDailog}
        handleOriginal={() => {
          printTallyReport("0");
        }}
        heading={"Confirmation"}
        handleDuplicate={() => {
          printTallyReport("1");
        }}
        onClose={() => {
          setisPrintTallyDailog(false);
        }}
      >
        Which receipt do you want to print?
      </DuplicateReceiptDialog>
      {/* Dialog for print destuffing report */}
      <DuplicateReceiptDialog
        isOpen={isPrintDestuffingDailog}
        handleOriginal={() => {
          printDestuffingReport("0");
        }}
        heading={"Confirmation"}
        handleDuplicate={() => {
          printDestuffingReport("1");
        }}
        onClose={() => {
          setisPrintDestuffingDailog(false);
        }}
      >
        Which receipt do you want to print?
      </DuplicateReceiptDialog>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        className={classes.menu}
        onClose={handleCloseActionBtn}
        onClick={handleCloseActionBtn}
      >
        {/* Edit */}
        {/* <Tooltip
          title={listAction?.editDisable ? "Old gate entry cannot be edited" : "Edit"}
          followCursor
        > */}
        <MenuItem
          onClick={() => {
            history.push(`/nod/gate-entry/gate-entry-details/${listAction?.vehicleId}`);
            handleCloseActionBtn();
          }}
          disabled={listAction?.vehicleStatus == "Checked-out"}
        >
          <ListItemIcon style={{ minWidth: "40px", color: "#1976d2" }}>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          Edit
        </MenuItem>
        {/* </Tooltip> */}
        {/* Checkout */}
        <MenuItem
          onClick={() => {
            history.push(
              localStorage.getItem("allowedRoutes")?.includes("/nod/gate-entry/gate-out")
                ? `/nod/gate-entry/gate-out-details/${listAction?.id}?container=${true}`
                : localStorage.getItem("defaultRoute") || ""
            );
            handleCloseActionBtn();
          }}
          disabled={!listAction?.vehicleInProgress}
        >
          <ListItemIcon style={{ minWidth: "40px", color: "red" }}>
            <RemoveCircleIcon fontSize="small" />
          </ListItemIcon>
          Checkout
        </MenuItem>
        {/* Print Gate-in receipt */}
        <MenuItem
          onClick={() => {
            setSelectedRecordId(listAction?.id);
            setIsOpenGateInPrintDailog(true);
            handleCloseActionBtn();
          }}
        >
          <ListItemIcon style={{ minWidth: "40px", color: "#72CA00" }}>
            <PrintSharp fontSize="small" />
          </ListItemIcon>
          Print Gate-in receipt
        </MenuItem>
        {/* Print Gate-out receipt */}
        <MenuItem
          onClick={() => {
            setSelectedRecordId(listAction?.id);
            setIsOpenGateOutPrintDailog(true);
            handleCloseActionBtn();
          }}
        >
          <ListItemIcon style={{ minWidth: "40px", color: "#72CA00" }}>
            <PrintSharp fontSize="small" />
          </ListItemIcon>
          Print Gate-out receipt
        </MenuItem>
        {/* Mark as invalid */}
        <MenuItem
          onClick={() => {
            setIsOpenConfirmationDailog(true);
            setInvalidVehicleId(listAction?.id);
            formik.setFieldValue("regNumber", listAction.vehicleNumber);

            handleCloseActionBtn();
          }}
          disabled={!listAction?.vehicleInProgress || listAction?.vehicleStatus == "Pending Review"}
        >
          <ListItemIcon style={{ minWidth: "40px", color: "red" }}>
            <CancelRounded fontSize="small" />
          </ListItemIcon>
          Mark as invalid
        </MenuItem>
        {/* Print telly receipt */}
        <MenuItem
          onClick={() => {
            setSelectedRecordId(listAction?.id);
            setisPrintTallyDailog(true);
            handleCloseActionBtn();
          }}
          disabled={terminalType === 4}
        >
          <ListItemIcon style={{ minWidth: "40px", color: "#72CA00" }}>
            <PrintSharp fontSize="small" />
          </ListItemIcon>
          Print Tally Report
        </MenuItem>
        {/* Print destuffing receipt */}
        <MenuItem
          onClick={() => {
            setSelectedRecordId(listAction?.id);
            setisPrintDestuffingDailog(true);
            handleCloseActionBtn();
          }}
          disabled={terminalType === 4}
        >
          <ListItemIcon style={{ minWidth: "40px", color: "#72CA00" }}>
            <PrintSharp fontSize="small" />
          </ListItemIcon>
          Print Destuffing Report
        </MenuItem>
      </Menu>
      <Box position="relative">
        <CommonDataGridPage
          module={moduleName}
          heading={pageHeading}
          GridDataComp={
            <CommonMaterialGrid
              rows={vehicleRecord}
              columns={displayColumns}
              loader={loader || loader2}
              defaultPerPageRecord={15}
              height={550}
              deletedRow={true}
              isExport={isExport}
              exportHandler={exportHandler}
              filename={`List_of_container_${Date.now()}`}
            />
          }
        >
          <>
            <Grid spacing={2} container direction="row">
              <Grid item xs={12} md={3} lg={2}>
                <CommonAutoCompleteField
                  cssClassName="customTextField"
                  error={formik.touched.filterBy && Boolean(formik.errors.filterBy)}
                  helperText={formik.touched.filterBy && formik.errors.filterBy}
                  label="Filter by"
                  placeholder="Filter by"
                  name="filterBy"
                  disableClearable={true}
                  optionsType={filteryByArr}
                  getOptionLabel={(option: any) => option.label || null}
                  onChange={(row: any) => {
                    row ? formik.setValues({ ...formik.values, filterBy: row.value || "" }) : "";
                    if (row === null) {
                      formik.setFieldValue("filterBy", null);
                    }
                    filterByAction(row);
                  }}
                  value={
                    filteryByArr.find(({ value }: any) => value === formik.values.filterBy) || ""
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
                lg={2}
                className={!isCustomDate ? classes.hideDatesGrid : ""}
              >
                <CommonTextFieldDate
                  cssClassName="customTextField"
                  label={"Start Date"}
                  name={"startDate"}
                  datePickerRef={startDatePickerRef}
                  value={formik.values.startDate}
                  onChange={(e: any) => {
                    formik.setFieldValue("startDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                    formik.setFieldValue("endDate", "");
                  }}
                  maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
                lg={2}
                className={!isCustomDate ? classes.hideDatesGrid : ""}
              >
                <CommonTextFieldDate
                  cssClassName="customTextField"
                  label={"End Date"}
                  name={"endDate"}
                  datePickerRef={endDatePickerRef}
                  value={formik.values.endDate}
                  onChange={(e: any) => {
                    formik.setFieldValue("endDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                  }}
                  minDate={formik.values.startDate}
                  maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                />
              </Grid>
              <Grid item xs={12} md={isCustomDate ? 3 : 4} lg={2} style={{ paddingRight: 0 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={Boolean(formik.values.InProgressVehiclesDataOnly)}
                      onChange={formik.handleChange}
                      name="InProgressVehiclesDataOnly"
                      color="primary"
                    />
                  }
                  label="In Progress Containers"
                />
              </Grid>

              <Grid item xs={12} md={isCustomDate ? 12 : 5} lg={isCustomDate ? 4 : 8}>
                <Box textAlign="right" mt={1} mb={1} style={{ float: "right" }}>
                  <CommonButton cssClass="customSubmitBtn" onClick={() => resetSearch()}>
                    Reset
                  </CommonButton>
                  <CommonButton cssClass="customSubmitBtn" isGreen onClick={handleSearch}>
                    Search
                  </CommonButton>
                </Box>
              </Grid>
            </Grid>
          </>
        </CommonDataGridPage>
        <Box
          position="absolute"
          top={35} // aligns vertically with heading
          left={170} // ← aligns after "Destuffing"
          zIndex={10}
        >
          <Tooltip title="Containers info">
            <IconButton size="small" onClick={() => setIsOpenInfoDailog(true)}>
              <Info fontSize="small" color="primary" />
            </IconButton>
          </Tooltip>
        </Box>
        <TransitionDialog
          isOpen={isOpenInfoDailog}
          handleClose={handleCloseInfoDialog}
          heading={"Infomation!"}
          maxWidth="sm"
          isCustomValidate={true}
        >
          <Box>
            <Typography gutterBottom>
              Containers shown in gray are On Hold and unavailable for processing.
            </Typography>
          </Box>
        </TransitionDialog>
      </Box>
      <TransitionDialog
        isOpen={isOpenConfirmationDailog}
        handleClose={() => handleCloseConfirmationDialog()}
        heading={"Confirmation"}
        handleConfirm={() => handleConfirmationDialog()}
      >
        Are you sure you want to mark this vehicle as invalid?
        <Box style={{ marginTop: "10px", marginBottom: "10px" }}>
          <TextField
            required
            multiline
            rows={1}
            rowsMax={5}
            size="small"
            fullWidth
            className="customTextField"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            label="Remarks"
            name="remarks"
            id="remarks"
            placeholder="Enter Remarks"
            disabled={false}
            value={formik.values.remarks}
            onChange={(e) => formik.setFieldValue("remarks", e.target.value)}
            error={formik.touched.remarks && Boolean(formik.errors.remarks)}
            helperText={formik.touched.remarks && formik.errors.remarks}
          />
        </Box>
        <Box>
          <CommonAutoCompleteField
            cssClassName="customTextField"
            disabled={false}
            label="Assign to"
            name="userId"
            placeholder="Select User"
            disableClearable={true}
            optionsType={allApprovalUserList?.filter(
              (list: any) => list?.userId != Number(localStorage?.getItem("nodUserId"))
            )}
            getOptionLabel={(option) => `${option.userName}`}
            required
            value={
              allApprovalUserList.find((st: any) => st.userId === formik.values.approvalUserId) ||
              null
            }
            onChange={(option: any) => {
              formik.setFieldValue("approvalUserId", option.userId);
              formik.setFieldValue("userName", option.userName);
            }}
            error={formik.touched.approvalUserId && Boolean(formik.errors.approvalUserId)}
            helperText={formik.touched.approvalUserId && formik.errors.approvalUserId}
          />
        </Box>
      </TransitionDialog>
    </>
  );
}
